<template>
  

  <div class="submit-form">
    <NavBar :tabs="navTabs" ref="nav_tabs" :paginate="false" :link="true"/>
    <h1 v-if="forms?.[$route.params.form_id]">{{forms?.[$route.params.form_id][0].name}}</h1>

    <div v-if="forms?.[$route.params.form_id][0] && forms?.[$route.params.form_id][0].organization_proxy" class="select-organization" :style="{'display': organization && $route.name=='submissions' ? 'none' : 'flex'}">
      <div class="select-organization-body">
        <h4>Select group/organization</h4>
        <p v-if="!organization">This form requires users to work on behalf of one group/organization.</p>
        <p v-if="!organization">This is necessary such that in the event of useres changing or leaving an organization their work will still be associated with that organization.</p>
        <SelectAsyncElement @change="organization=$event" :filter="selectOrganizationFilter" label="Select Organization" :url="$store.getters.getApiUrl+'groups/'+$route.params.form_id" data_name="groups" :required="true"/>
      </div>
    </div>
    <template v-if="!forms?.[$route.params.form_id][0].organization_proxy || organization">
      <Submissions :organization="organization" ref="submissions" :forms="forms" :form_elements="form_elements" :style="{'display': $route.name!='submissions' ? 'none' : 'block'}"/>
      <CustomForm :organization="organization" :forms="forms" :form_elements="form_elements" v-if="$route.name=='submit'"/>
      <FormBescheide v-if="$route.name=='bescheide'"/>
    </template>
  </div>

</template>

<script>

import Submissions from '@/components/submit_form/Submissions.vue'
import CustomForm from '@/components/submit_form/CustomForm.vue'
import FormBescheide from '@/components/forms/submission/FormBescheide.vue'
import SelectAsyncElement from '@/components/inputs_23/SelectAsyncElement.vue'
import NavBar from '@/components/NavBar.vue'
export default {
  name: 'SubmitForm',
  props: {
  },
  components: {
    NavBar,
    Submissions,
    CustomForm,
    FormBescheide,
    SelectAsyncElement,
  },
  data() {
    return {
      awaiting_form_data: false,
      forms: null,
      form_elements: null,
      organization: null,
    }
  },
  computed: {
    navTabs() {
      var navTabs = [
        {id: 0,text: 'Submissions', route: {name: 'submissions',query: this.$route.query, params: {form_id:this.$route.params?.form_id}}},
        {id: 1, text: 'Submit Form', route: {name: 'submit',query: this.$route.query, params: {form_id:this.$route.params?.form_id}}},
      ]
      if(this.forms?.[this.$route.params.form_id][0]?.form_bescheid_settings.length>0) {
        navTabs = [...navTabs, {id: 2, text: 'Bescheide', route: {name: 'bescheide',params: {form_id:this.$route.params?.form_id}}}]
      }
      // } else {
      // navTabs = [...navTabs, {id: 3, text: 'Info', route: {name: 'info'}}]
      // }
      return navTabs
    },
  },
  mounted() {
    console.log('mounted submitform')
    this.form = this.getForm(this.$route.params.form_id)
  },
  methods: {
    selectOrganizationFilter(groups) {
      return groups.filter(group=>{
        var veto = true
        this.forms?.[this.$route.params.form_id][0].organizations_regex.forEach(regex_string=>{
          const regex = new RegExp(regex_string)
          if(regex.test(group.name)) {
            return veto=false
          }
        })
        return !veto
      })

    },
    async getForm(form_id) {
      this.awaiting_form_data = true
      const params = {key:'jd(3.3329djHaiJK3023ld0OD=3'}
      const {forms,form_elements} = await this.$store.dispatch('__forms__',{form_id,params})
      console.log(forms,form_elements)
      this.forms = forms
      this.form_elements = form_elements
      this.awaiting_form_data = false
    },
  }
}
</script>

<style lang="scss" scoped>
h1 {
  width: 100%;
  max-width: 100vw;
  text-align: center;
}
.select-organization {
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .select-organization-body {
    border: 1px solid black;
    border-radius: 8px;
    padding: 1rem;
    background-color: white;
    width: 210mm;
  }
}
</style>